export type AuthMode = "external_id" | "mock";

function readAuthMode(raw: string | undefined): AuthMode {
  // "mock" precisa ser pedido explicitamente; qualquer outro valor cai no
  // modo de produção com Microsoft Entra External ID.
  return raw === "mock" ? "mock" : "external_id";
}

export const config = {
  authMode: readAuthMode(import.meta.env.VITE_AUTH_MODE),
  apiUrl: (import.meta.env.VITE_API_URL || "http://localhost:7860").replace(/\/$/, ""),
  externalId: {
    clientId: import.meta.env.VITE_EXTERNAL_ID_CLIENT_ID || "",
    authority: import.meta.env.VITE_EXTERNAL_ID_AUTHORITY || "",
    knownAuthority: import.meta.env.VITE_EXTERNAL_ID_KNOWN_AUTHORITY || "",
    apiScope: import.meta.env.VITE_EXTERNAL_ID_API_SCOPE || "",
    redirectUri: import.meta.env.VITE_PORTAL_REDIRECT_URI || window.location.origin,
  },
  useMockApi: import.meta.env.VITE_USE_MOCK_API === "true",
} as const;
